import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { Navigation, ScrollToTop } from "./components/navigation";
import { Header } from "./components/header";
import { News } from "./components/news";
import { PopupForm } from "./components/popup_form";
import { HeroBanner } from "./components/HeroBanner";
import { UseCases } from "./components/UseCases";
import { Architecture } from "./components/architecture";
import { ClientsProposition } from "./components/clients_proposition";
import { Vendors } from "./components/vendors";
import { Contact } from "./components/contact";
import { Team } from "./components/team";
import { Teaching } from "./components/teaching";
import { AboutCompany } from "./components/about_company";
import SoftwareRegistry from "./components/SoftwareRegistry";
import { RosRegistryBanner } from "./components/RosRegistryBanner";
import PrivacyPolicy from "./components/PrivacyPolicy";
import UserAgreement from "./components/UserAgreement";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
// import ScrollToTop from "./components/ScrollToTop";


export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const HomePage = ({ landingPageData, openPopup }) => {
  return (
    <>
      {/* <Header data={landingPageData.Header} /> */}
      <HeroBanner data={landingPageData.HeroBanner} />
      <UseCases data={landingPageData.UseCases} />
      <ClientsProposition data={landingPageData.ClientsProposition} />
      <RosRegistryBanner />
      <Vendors data={landingPageData.Vendors} />
      <Contact openPopup={openPopup} data={landingPageData.Contact} />
    </>
  );
};

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <Router>
      <div>
        <ScrollToTop />
        <Navigation openPopup={openPopup}/>
        <PopupForm isOpen={isPopupOpen} closePopup={closePopup} data={landingPageData.PopupForm} />
        <Routes>
          <Route 
            path="/" 
            element={
              <HomePage 
                landingPageData={landingPageData}
                openPopup={openPopup}
              />
            } 
          />
          <Route path="/legal/docs" element={<SoftwareRegistry />} />
          <Route path="/about" element={<AboutCompany landingPageData={landingPageData} openPopup={openPopup} />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/legal/user-agreement" element={<UserAgreement />} />
          {/* Перенаправление всех несуществующих страниц на главную */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
